import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3fd4e313"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "aria-labelledby"]
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title fw-bold text-center w-100 fs-9" }
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "text-center content" }
const _hoisted_8 = { class: "modal-footer d-flex justify-content-center border-top-0" }
const _hoisted_9 = { class: "d-flex justify-content-center" }

import { translate } from '@/languages/i18n'
import { PropType } from 'vue'
import Button from '@/components/button/index.vue'
import { DELETE_COMPLETE_MODAL_ID } from '@/views/community-admin/community-site/constants'


export default /*#__PURE__*/_defineComponent({
  props: {
  id: {
    type: String,
    default: DELETE_COMPLETE_MODAL_ID,
  },
  header: {
    type: String,
    default: translate('CK16DeleteArticle'),
  },
  contentMessage: {
    type: String,
    default: translate('deleteSuccess'),
  },
  button: {
    type: String,
    default: translate('close'),
  },
  buttonClick: {
    type: Function as PropType<() => void | undefined>,
  },
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: __props.id,
    tabindex: "-1",
    "aria-labelledby": __props.id,
    "aria-hidden": "true",
    onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (__props.buttonClick && __props.buttonClick(...args)), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(__props.header), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (__props.buttonClick && __props.buttonClick(...args)))
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(__props.contentMessage), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(Button, {
              title: __props.button,
              type: 'secondary',
              "data-bs-dismiss": "modal",
              class: "me-2",
              onClick: __props.buttonClick
            }, null, 8, ["title", "onClick"])
          ])
        ])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})